import { combineReducers } from 'redux'
import HGReducers from './BasicApiReducers';

const rootReducer = combineReducers({
    HGReducers,
})
export default rootReducer;


